import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const costCenterBaseUrl = `${apiUrl}/costCenter`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const costCentersApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${costCenterBaseUrl}?${query}`);
  },
  save: costCenter => {
    return Axios.post(costCenterBaseUrl, costCenter, config);
  },
  delete: id => {
    return Axios.delete(`${costCenterBaseUrl}/${id}`, config);
  },
  upload: (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return Axios.post(`${costCenterBaseUrl}/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
